import httpClient from "./httpClient";
const getDepartments = (role = 'agent') =>
    httpClient.get("/api/users/getDepartments", {
      params: { role },
    });
export { getDepartments };
